import $ from 'jquery';

$(document).ready(function () {
    $('.collapse__toggle').on('click', function (element) {
        $(this).closest('.card').find('.collapse').collapse('toggle');
        $(this).toggleClass('is-open');
        window['scrolInstance'].update();
    });
});

function onAccordionToggle() {
    window['scrolInstance'].update();
}

function initialiseAccordionLocoUpdate() {
    // Ideally I would use this code but it only seems to work using jQuery event binding
    // document.querySelectorAll('.collapse').forEach(accordion => {
    //     accordion.addEventListener('hidden.bs.collapse', () => onAccordionToggle());
    //     accordion.addEventListener('shown.bs.collapse', () => onAccordionToggle());
    // })

    $('.collapse').on('shown.bs.collapse', () => onAccordionToggle());
    $('.collapse').on('hidden.bs.collapse', () => onAccordionToggle());
}

export {
    initialiseAccordionLocoUpdate,
}